import React, { Component } from 'react';
import Highcharts from 'highcharts';
import Highstock from 'highcharts/highstock';

import chartUtils from '../../util/chartUtils';
// Import Style
import './NoData.scss';

export default class NoData extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      shape: props.shape || 'columns'
    };
  }

  componentDidMount() {
    this.updateShape();
  }

  componentDidUpdate() {
    this.updateShape();
  }

  updateShape() {
    if (this.props.shape || !this.box || !this.box.parentElement) {
      return;
    }
    const element = this.box.parentElement.querySelector('[data-highcharts-chart]');
    const chart = element && [...Highcharts.charts, ...Highstock.charts].find(item => item && item.renderTo === element);
    if (!chart) {
      return;
    }
    const shape = chartUtils.shapeForChartType((chart.series[0] && chart.series[0].type) || chart.options.chart.type);
    if (shape !== this.state.shape) {
      this.setState({ shape });
    }
  }

  render() {
    if (this.props.loading || this.props.show) {
      const shape = this.props.shape || this.state.shape;
      return (
        <div className={`no_data ${this.props.className}`} ref={box => { this.box = box; }}>
          <h3>{this.props.title}</h3>
          <div
            className={`chart-placeholder chart-placeholder--${shape} ${this.props.loading ? 'chart-placeholder--loading' : ''}`}
            dangerouslySetInnerHTML={{ __html: chartUtils.placeholderMarkup(shape, this.props.loading) }}
          />
        </div>
      );
    }

    return null;
  }
}
